import withFormikSelect from "./withSelectFormik";
import withInputErrorMessage from "../withInputErrorMessage";
import withOptionsSelectValueInitById from "./withOptionsSelectValueInitById";

export const options = [
   {
      value: 'ALL',
      label: 'All',
      name: 'All',
   },
   {
      value: 'ACTIVE',
      label: 'Active',
      name: 'Active',
   },
   {
      value: 'INACTIVE',
      label: 'Inactive',
      name: 'Inactive',
   },
];

export default withFormikSelect(withInputErrorMessage(withOptionsSelectValueInitById(options)));
